import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(
    localStorage.getItem("SA_user_theme") || "light"
  );

  // Sync across tabs
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === "SA_user_theme") {
        setTheme(e.newValue || "light");
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  // Update localStorage when theme changes
  const updateTheme = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem("SA_user_theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme: updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeStore = () => useContext(ThemeContext);
